import GamesPresentation from 'components/Games/GamesPresentation'

export default {
  Presentation: GamesPresentation,
}
